<template>
  <div v-if="trip.load_trip_date" class="trip-main">
    <div class="content-block">
      <div class="">
        <h4>Данные погрузки выгрузки из почты</h4>
        <p>
          <strong>Погрузка:</strong> 
          {{ trip.load_trip_date }}:{{ trip.load_trip_time }}
        </p>
        <p>
          <strong>Выгрузка:</strong> 
          {{ trip.arrival_trip_date }}:{{ trip.arrival_trip_time }}
        </p>
      </div>

      <div class="datetime-correct-block" >
        <h4>Корректировка погрузки выгрузки</h4>
        <div class="load-datetime-correct">
          <div v-if="!redactForm" class="text-date-time">
            <p>
              <strong>Дата:</strong>
              <span v-if="trip.final_load_datetime">{{ trip.final_load_datetime }}</span>
              <span v-else> Не корректировалась</span>
            </p>
          </div>
          <div v-else class="input-date-time">
            <div><input type="date" name="" v-model="loadForm.date"></div>
            <div><input type="time" name="" v-model="loadForm.time"></div>
          </div>
        </div>
        <div class="load-correct-buttons">
          <div v-if="redactForm">
            <button v-if="statusSendForm" @click="saveForm">Сохранить</button>
            <button v-else  disabled>Сохранить</button>
            <button  @click="redactForm = false">Отменить</button>
          </div>
          
          <div v-else-if="!redactForm">
            <button  @click="redactForm=true">Изменить время</button>
          </div>
          
          
          <CargoTripScreen @fileStatus="fileStatus" v-if="!trip.approval_factory_screenshot" :tripId="trip.id" class=""/>
          <div v-else><p >Фаил загружен</p></div>
        </div>
      </div>
    </div>

    
      

  </div>
  <div class="trip-main" v-else>
    <div class="content-block">
      <div class="">
        <h4>Нет данных о времени погрузки с почты</h4>
      </div>
    </div>
  </div>
</template>

<script>
import {computed,ref} from 'vue'
import CargoTripScreen from '@/pages/trip/components/CargoTripScreen'



export default {
  name: 'LoadInfo',
  props: ['trip'],
  components:{
    CargoTripScreen,
  },
  setup(props,{emit}){

    const redactForm = ref(false)
    const confirm = ref(false)
    const fullCorrectDate = props.trip.approval_factory_screenshot

    const loadForm = ref({date:'2023-11-15',time:"12:00"})
    

    const checkDates = (date1,date2) =>{
      const dt1 = new Date(date1).setHours(0,0,0,0);
      const dt2 = new Date(date2).setHours(0,0,0,0);
      if (fullCorrectDate || dt1>dt2){
        return 1
      }else if(dt1==dt2){
        return 2
      }
      else{
        return -1
      }
    }

    const fileStatus = (status)=>{
      emit("fileStatus",status)
    }

    const checkTime = (time1,time2) =>{
      var date1 =  new Date();
      date1 = date1.setHours.apply(date1, time1.split(":"));
      var date2 =  new Date();
      date2 = date2.setHours.apply(date2, time2.split(":"));
      var diff = date2 - date1;
      if (fullCorrectDate || diff < 0){
        return true
      }else{
        return false
      }
    }

    const statusSendForm = computed(()=>{
      const timeSuccess = checkTime(props.trip.load_trip_time,loadForm.value.time)
      const dateSuccess = checkDates(props.trip.load_trip_date,loadForm.value.date)
      if(dateSuccess ===1){
        return true
      }else if(dateSuccess===2 && timeSuccess){
        return true
      }else{
        return false
      }
    })


    const saveForm = () =>{
      redactForm.value = false
      emit('updateLoadTime',loadForm.value)
    }

    const saveScreenshot =()=>{

    }

    return{
     fileStatus,
     saveScreenshot,
     statusSendForm,
     loadForm,
     confirm,
     redactForm,
     saveForm,
    }
  }
};
</script>

<style scoped>
h4{
  margin-bottom: 10px;
}

.load-datetime-correct{
  height: 40px;
  display: flex;
  justify-content: center;
}

.text-date-time{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.input-date-time{
  display: flex;
}

.load-correct-buttons{
  display: flex;
  align-items: center;
  justify-content: center;
}

.load-correct-buttons button {
  margin-top: 10px;
  margin-right: 10px;
  padding: 5px;
}

.load-datetime-correct input{
  width: 150px;
}

.datetime-correct-block{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.trip-main{
  padding: 25px 10px;
  border-radius: 10px;
  margin-top: 15px;
  border: 1px solid #ccc;

}

.content-block{
  display: flex;
  flex: 1; /* Добавьте это свойство, чтобы блоки занимали одинаковое пространство */
  padding: 10px; /* Добавьте отступ для блоков, чтобы сделать их более просторными */
  box-sizing: border-box; /* Учтите отступы внутри блоков */
}

.content-block div {
  width: 100%;
}

.mr-t-10{
  margin-top: 10px;
}
</style>